export const NOT_AUTHORIZED_EXCEPTION = 'NotAuthorizedException';
export const SERVER_IS_DOWN_EXCEPTION = 'ServerIsDownException';
export const NO_NETWORK_EXCEPTION = 'NoNetworkException';
export const UNKNOWN_EXCEPTION = 'UnknownException';
export const BAD_REQUEST = 'BadRequest';
export const FAILED_TO_PROCESS_REQUEST_EXCEPTION =
  'FailedToProcessRequestException';
